<template>
    <span
        v-for="route in displayRoutes"
        :key="route"
        @click="goToRoute(route.path)"
        :class="`btn btn-vue btn-block-vue ${isActivePath(route.path) ? 'active' : ''}`"
    >
        <b>{{ route.meta.menuName }}</b>
    </span>
    <a
        v-if="hasCertificationAccess && showBellIcon && !canViewReports"
        href="javascript:void(0)"
        @click="redirectToCertification"
        class="btn btn-vue btn-block-vue d-flex align-items-center justify-content-between"
    >
        <div><b>Axxess Training and </b><br /><b> Certification </b></div>
        <i
            class="far fa-bell"
            style="color: #337ab7 !important; font-size: 20px"
            v-tooltip="{
                title: `New Courses Now Live`,
                placement: 'top',
                className: 'lock-premium'
            }"
        ></i>
    </a>

    <a
        v-if="hasCertificationAccess && !showBellIcon && !canViewReports"
        target="_blank"
        :href="certificationUrl"
        class="btn btn-vue btn-block-vue"
    >
        <b>Axxess Training and </b><br /><b> Certification </b>
    </a>
    <div id="App__Agencies_Vue" v-if="getCertificationAccess && canViewReports">
        <header class="group-title-vue" @click="toggleTrainingListShow()">
            <span>Axxess Training and Certification </span>
            <i :class="`me-1 ms-auto arrow-color fas fa-caret-${listShow ? 'down' : 'up'}`"></i>
        </header>
        <a target="_blank" :href="certificationUrl" class="btn btn-vue btn-block-vue" v-show="trainingListShow">
            <b>Training Hub</b>
        </a>
        <a target="_blank" :href="certificationReportsUrl" class="btn btn-vue btn-block-vue" v-show="trainingListShow">
            <b>Training Reports</b>
        </a>
    </div>
    <!-- Hiding premium feature until asked to unhide -->
    <!-- <div id="App__Agencies_Vue" v-if="simitreeHHPermission || simitreeHOSPermission"
        :class="`${!canShowPremium ? 'ai-disabled' : ''}`">
        <header class="group-title-vue" @click="toggleListShow()">
            <span>SimiTree</span>
            <div class="d-flex" v-if="canShowPremium">
                <button class="ai-premium-btn ms-2">Premium</button>
            </div>
            <div class="d-flex" v-else>
                <button
                    class="ai-premium-btn ms-2"
                    v-tooltip="{
                        title: `Contact Axxess to unlock this <br /> premium Axxess intelligence feature.`,
                        placement: 'top',
                        className: 'lock-premium'
                    }"
                >
                    Premium
                    <img src="../../../../assets/images/lock-planner.svg" />
                </button>
            </div>
            <i :class="`me-1 ms-auto arrow-color fas fa-caret-${listShow ? 'down' : 'up'}`"></i>
        </header> -->
    <div
        id="App__Agencies_Vue"
        v-if="simitreeHHPermission || simitreeHOSPermission"
        :class="`${!canShowPremium ? 'ai-disabled' : ''}`"
    >
        <header class="group-title-vue" @click="toggleListShow()">
            <span>SimiTree</span>
            <i :class="`me-1 ms-auto arrow-color fas fa-caret-${listShow ? 'down' : 'up'}`"></i>
        </header>
        <a
            v-if="simitreeHHPermission"
            target="_blank"
            :href="simiTreeHHUrl"
            class="btn btn-vue btn-block-vue"
            v-show="listShow"
        >
            <b>SimiTree MAP Home Health</b>
        </a>
        <a
            v-if="simitreeHOSPermission"
            target="_blank"
            :href="simiTreeHOSUrl"
            class="btn btn-vue btn-block-vue"
            v-show="listShow"
        >
            <b>SimiTree MAP Hospice</b>
        </a>
    </div>
</template>

<script lang="ts" src="./AppNav.ts"></script>
